export default __webpack_public_path__ + "static/media/banner-welcome.39bf18f3.png";